export interface ISendNotifications
  extends Components.Schemas.ISendNotifications {}
export enum ENotificationRecipients {
  ALL = 'ALL',
  SELLERS = 'SELLERS',
  USERS = 'USERS'
}
export interface NotificationData extends Components.Schemas.NotificationData {}
export interface InternalPushMessageData
  extends Components.Schemas.InternalPushMessageData {}
export interface ExternalPushMessageData
  extends Components.Schemas.ExternalPushMessageData {}

export enum ENotificationType {
  ORDER = 'ORDER',
  PRODUCT = 'PRODUCT',
  COLLECTION = 'COLLECTION',
  FAVORITES = 'FAVORITES',
  SUBCATEGORY = 'SUBCATEGORY'
}

// Центр уведомлений

export enum ECampaignChannel {
  PUSH = 'push',
  EMAIL = 'email',
  BOT = 'bot',
  SMS = 'sms',
  POPUP = 'popup'
}

export type TCampaignStatus =
  | 'scheduled'
  | 'queued'
  | 'running'
  | 'completed'
  | 'failed'
  | 'canceled'

export interface IBroadcastSellers {
  push?: boolean
  bot?: boolean
  email?: boolean
  sms?: boolean
  popup?: boolean
  popup_notify_new_sellers?: boolean
  popup_button_text?: string | null
}

// Условия складываются через «и»; заказы — только оплаченные
export interface IBroadcastSegments {
  in_cart?: boolean
  registered_after?: string | null
  no_orders_days?: number | null
}

export interface IBroadcastUsers {
  push?: boolean
  email?: boolean
  marketing_only?: boolean
  segments?: IBroadcastSegments | null
}

export interface IBroadcastAudienceRequest {
  sellers?: IBroadcastSellers
  users?: IBroadcastUsers
  data?: InternalPushMessageData | ExternalPushMessageData
  // С текстом считается стоимость SMS, со временем — у скольких продавцов ночь
  sms_text?: string
  scheduled_at?: string
}

export interface ISendBroadcast extends IBroadcastAudienceRequest {
  title: string
  body: string
  quiet_hours?: boolean
}

export interface ITestBroadcast extends ISendBroadcast {
  test_phone?: string
}

export interface ITestBroadcastResult {
  results: Partial<
    Record<
      Exclude<ECampaignChannel, ECampaignChannel.POPUP>,
      { ok: boolean; detail: string }
    >
  >
}

export interface IBroadcastPreview {
  email_subject: string
  email_html: string
  bot_message: string
  site_url: string | null
  link_label: string | null
}

export interface ISmsCost {
  total_cost: number
  total_sms: number
}

export interface IBroadcastAudience {
  sellers: {
    // Одобренные продавцы
    total: number
    // Устройства, а не аккаунты
    push: number
    // Продавцы с подключённым ботом; чатов может быть меньше — один владелец у нескольких магазинов
    bot: number
    bot_telegram: number
    bot_max: number
    email: number
    sms: number
    popup: number
    // У скольких продавцов ночь в момент отправки
    night: number
  }
  users: {
    push: number
    email: number
  }
  // Общие для продавцов и покупателей устройства и адреса получают сообщение один раз
  total: {
    push: number
    email: number
  }
  // null — SMS не выбраны или sms.ru не ответил
  sms_balance: number | null
  sms_cost: ISmsCost | null
}

export interface ICampaignChannel {
  key: ECampaignChannel
  total: number
  sent: number
  failed: number
  status: TCampaignStatus
  error: string | null
  // Остаток канала ждёт 9:00 у продавцов, у которых ночь
  next_at?: string | null
}

interface ICampaignAdmin {
  _id: string
  name?: string
  surname?: string
  email?: string
}

export interface INotificationCampaign {
  _id: string
  campaignId?: string
  to: ENotificationRecipients
  // Рассылки до центра уведомлений шли одним каналом, у новых — channels
  channel: ECampaignChannel.PUSH | ECampaignChannel.EMAIL | null
  channels?: ICampaignChannel[]
  audience?: { sellers?: IBroadcastSellers; users?: IBroadcastUsers } | null
  notificationData: NotificationData
  sms_text?: string | null
  popup_id?: string | null
  created_by?: ICampaignAdmin | null
  status: TCampaignStatus
  total: number
  sent: number
  failed: number
  dryRun: boolean
  error?: string | null
  scheduled_at?: string | null
  quiet_hours?: boolean
  repeat_of?: string | null
  // Стоимость по sms.ru на момент отправки
  sms_cost?: number | null
  createdAt: string
  startedAt?: string | null
  completedAt?: string | null
  canceledAt?: string | null
  canceled_by?: ICampaignAdmin | null
}
